export const categoryKeyFactory = {
  all: [{ scope: 'category' }] as const,
  list: () => [{ ...categoryKeyFactory.all[0], entity: 'list' }] as const,
}
